import 'react-dates/initialize';
import React, { Component, Fragment } from 'react';
import 'react-dates/lib/css/_datepicker.css';
import { connectRange } from 'react-instantsearch-dom'
import moment from '../utils/momentTimeZone';
import $ from 'jquery'
import CalendarStrip from './calendar-strip/CalendarStrip';

const CalendarStripRefinement = connectRange(({
    refine,
    searchState,
    currentRefinement,
}) => {
    return <CalendarStripWrapper refine={refine} currentRefinement={currentRefinement} searchState={searchState} />
})

const BackToTop = () => (
    <h5 className="c-CalendarStrip--row-label">
        <a href="#top" data-scroll="">Back to top</a>
    </h5>
)

class CalendarStripWrapper extends Component {

    constructor(props) {
        super(props)
        this.state = {
            selected: null
        }

        if (this.props.searchState &&
            this.props.searchState.range &&
            this.props.searchState.range.unixDay &&
            this.props.searchState.range.unixDay.min) {
            this.startDay = this.props.searchState.range.unixDay.min
        } else {
            this.startDay = moment().startOf('day').unix()
        }

        this.refine = refinement => {
            props.refine(refinement)
            this.currentRefinement = refinement
        }
        this.currentRefinement = props.currentRefinement
        this.applyRefinement = this.applyRefinement.bind(this)
    }

    loadMoreNextWeek = () => {
        const updatedRefinement = Object.assign({}, this.currentRefinement)
        updatedRefinement.max += 604800 // 604800 = 7 Days in seconds
        this.refine(updatedRefinement) 
    }

    componentDidMount = () => {
        this.$calendarStrip = $('.c-CalendarStrip')
        this.topOfCalendarStrip = $('#topOfCalendarStrip').offset().top
        
        window.addEventListener("whatson:load-more", this.loadMoreNextWeek);
    }

    componentWillUnmount = () => {
        window.removeEventListener("whatson:load-more", this.loadMoreNextWeek);
    }


    applyRefinement(selected) {

        if(this.$calendarStrip.offset().top > this.topOfCalendarStrip) {
            $('html, body').animate({
                scrollTop: this.topOfCalendarStrip
            });
        }


        this.setState({ selected })
        this.refine({min: selected, max: moment.unix(selected).add(1, 'week').unix()})
    }

    render() {
        return (
            <Fragment>
                <div id="topOfCalendarStrip"></div>
                <CalendarStrip startDay={this.startDay} dayLabel={BackToTop} onDatesChange={this.applyRefinement} />
            </Fragment>
        );
    }
}

export default CalendarStripRefinement;



// WEBPACK FOOTER //
// ./src/whatson/components/CalendarStripRefinement.js